/**
 * 程序入口
 */

// 基本组件
import Vue from 'vue'
import router from './router/router'
import store from './store/store'
import ElementUI from 'element-ui'
import {sync} from 'vuex-router-sync'
import ibroadcast from './components/ibroadcast.vue'
import axios from 'axios'
import 'element-ui/lib/theme-default/index.css'
import { MessageBox } from 'element-ui'
import { routeMap } from './utils/com.js'
import { MOCK_DEBUG, API_HOST, roleType } from './config/config'
import CryptoJS from 'crypto-js'
console.info("API_HOST:'%s'", API_HOST)

/*微信调试*/
import VConsole from 'vconsole'
var vConsole = new VConsole();
/*虚拟数据调试*/
// import Mock from './ipmock'
if(MOCK_DEBUG){
    // Mock.bootstrap();
}

Vue.use(ElementUI)





// 注册导航全局钩子，检查是否已登录
router.beforeEach((to, from, next) => {
    console.debug("beforeEach> to:%o", to);
    let token = store.getters.getToken || store.getters.getAccesstoken
    let role = store.getters.getRole || ''
    console.debug("beforeEach> token:%o, role:%o", token, role);
    if (token != null && to.path == routeMap('/login') ) {
        // 已登录不能进入登录页
        next( routeMap('/') )
    }
    // console.log(1);
    //微信公众号登录跳转解决方案 
     let wxtoken = to.query.token || '';
     let pageType = to.query.type || '';
     let appid = to.query.appid || '';
     let wxLogin = {
            name: '',
            password: ''
        };
    if(appid && wxtoken && pageType==='press'){      
         //生成token
         var exp = new Date();
         let timestamp = Math.round(exp.getTime()/60000);
         // console.debug("timestamp:%o", timestamp);
         let tempstr = 'wxgzh' + 'wxgzh171122' + timestamp;
         let tmeptoken = CryptoJS.MD5(tempstr).toString();
         // console.debug("tempstr:%s, tmeptoken:%s", tempstr, tmeptoken);
         let finaltoken = (timestamp + tmeptoken).toUpperCase();

        // console.log(finaltoken);
        // let param = { appid, wxtoken};
        // this.wxTokenLogin(param);        
        wxLogin.name = appid;
        wxLogin.password = finaltoken;
        store.dispatch('TokenLogin', wxLogin);
        next(routeMap('/press'));    
    }else if(appid && wxtoken && pageType==='joke'){
         //生成token
         var exp = new Date();
         let timestamp = Math.round(exp.getTime()/60000);
         // console.debug("timestamp:%o", timestamp);
         let tempstr = 'wxgzh' + 'wxgzh171122' + timestamp;
         let tmeptoken = CryptoJS.MD5(tempstr).toString();
         // console.debug("tempstr:%s, tmeptoken:%s", tempstr, tmeptoken);
         let finaltoken = (timestamp + tmeptoken).toUpperCase();

        // console.log(finaltoken);
        // let param = { appid, wxtoken};
        // this.wxTokenLogin(param);        
        wxLogin.name = appid;
        wxLogin.password = finaltoken;
        store.dispatch('TokenLogin', wxLogin);
        next(routeMap('/joke/list'));
    }
    // console.log(2);
    //if (token === null && to.path !== '/login' && to.path !== '/404') {
    if (token === null && to.path !== routeMap('/login') && to.path !== routeMap('/404') ){
        // 未登录
        // next( routeMap('/login') )
        // console.log(4);
        next({
            path: routeMap('/login'),
            query: to.query
        })
    } else {
        // // console.log(5);
        // // only can be jump to role's site
        // console.debug("beforeEach> role:%o, roleType:%o", role, roleType[role]);
        // if(role && roleType[role] && !new RegExp("^" + roleType[role],"gim").test(to.name)){
        //     // console.log(6);
        //     console.debug("beforeEach> to.name test fail. to.name:%s, roleType:%s", to.name, roleType[role]);
        //     next( routeMap(`/${roleType[role]}/`) )
        // }else{
        //     // console.log(7);
        //     console.debug("beforeEach> to.name test pass. to.name:%o, roleType:%o", to.name, roleType[role]);
        //     next()
        // }
        next();
    }
    // console.log(3);

})

// 注册全局模版数据过滤器
Vue.filter('enableStatus', function (value) {
    return value === '1' ? '启用中' : '已禁用'
})

// 添加接口回调拦截器
axios.interceptors.response.use(function (response) {
    console.debug("axios.interceptors> response:%o", response);
    if(response.status === 200) {
        let request = response.request || {responseURL:''}
        let urlarr = request.responseURL.split('/') || []
        console.debug("axios.interceptors> request:%o, urlarr:%o", request, urlarr);
        if(parseInt(response.data.code) === 9 && urlarr[urlarr.length - 1] !==
            'login') {
            // token过期，执行退出登录
            console.warn("token过期，执行退出登录");
            MessageBox.alert("token过期，执行退出登录", { confirmButtonText: '确定', type: 'error' })
            store.dispatch('outLogin')
            // this.$router.push({ path: routeMap('/login')})
            // window.location.pathname = routeMap('/login')
            let type = urlarr[urlarr.length - 2]
            vm.$router.push({ path: routeMap('/login'),query: { type: type }});
        } else {
            return response.data;
        }
    }else {
        // MessageBox.alert('接口通讯失败，请尝试刷新页面或者重新登录。如果还是存在问题，请联系管理员', '系统通知', { confirmButtonText: '确定', type: 'error' })
        MessageBox.alert(response.data.msg, { confirmButtonText: '确定', type: 'error' })
    }

}, function (error) {
    console.debug("axios.interceptors> error:%o", error);
    MessageBox.alert('接口通讯失败，请尝试刷新页面或者重新登录。如果还是存在问题，请联系管理员', '系统通知', { confirmButtonText: '确定', type: 'error' })
    return Promise.reject(error);
})

sync(store, router);

var vm = new Vue({
    el: '#ibroadcast',
    router,
    store,
    render: h => h(ibroadcast)
})



// WEBPACK FOOTER //
// ./src/main.js